// ============================================================
// Pela Case — PDP Gallery Event Tracking
// Version: 1.0
// Events: pdp_image_swipe, pdp_thumbnail_click, 
//         pdp_image_zoom, pdp_video_play, pdp_gallery_depth
// ============================================================

(function () {
  if (!window.location.pathname.includes('/products/')) return;

  var gallery = document.querySelector('#productMain');
  if (!gallery) return;

  // ── Shared helpers ────────────────────────────────────────

  function getProductInfo() {
    return {
      product_id: (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product)
        ? window.ShopifyAnalytics.meta.product.id : null,
      product_name: document.querySelector('.product__title, h1.title')
        ? document.querySelector('.product__title, h1.title').innerText.trim() : null,
    };
  }

  function getActiveSlideIndex() {
    var current = gallery.querySelector('.fm-slider__slide.is-current');
    return current ? parseInt(current.dataset.slideIndex, 10) : null;
  }

  function getTotalSlides() {
    return gallery.querySelectorAll('.fm-slider__slide').length;
  }

  function push(eventName, extraParams) {
    var info = getProductInfo();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      gallery_total_slides: getTotalSlides(),
      product_id: info.product_id,
      product_name: info.product_name,
    }, extraParams));
  }

  // ── Shared touch state ────────────────────────────────────

  var touchStartX = 0;
  var touchStartY = 0;
  var SWIPE_THRESHOLD = 30;

  gallery.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
  }, { passive: true });

  // ── 1. Image Swipe ────────────────────────────────────────

  var lastSwipePosition = 1;

  gallery.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;

    setTimeout(function () {
      var newPosition = getActiveSlideIndex();
      if (!newPosition || newPosition === lastSwipePosition) return;

      push('pdp_image_swipe', {
        swipe_direction: dx < 0 ? 'left' : 'right',
        gallery_from_position: lastSwipePosition,
        gallery_to_position: newPosition,
      });

      lastSwipePosition = newPosition;
    }, 300);
  }, { passive: true });

  // ── 2. Thumbnail Click ────────────────────────────────────

  gallery.addEventListener('click', function (e) {
    var dot = e.target.closest('.js-fm-slider-dot');
    if (!dot) return;
    var parts = dot.id.split('-');
    var position = parseInt(parts[parts.length - 1], 10) + 1;

    push('pdp_thumbnail_click', {
      gallery_position: position,
    });
  });

  // ── 3. Image Zoom (pinch) ─────────────────────────────────

  var initialPinchDistance = null;
  var zoomFired = false;

  function getPinchDistance(e) {
    var dx = e.touches[0].clientX - e.touches[1].clientX;
    var dy = e.touches[0].clientY - e.touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  gallery.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) initialPinchDistance = getPinchDistance(e);
  }, { passive: true });

  gallery.addEventListener('touchmove', function (e) {
    if (e.touches.length !== 2 || !initialPinchDistance || zoomFired) return;
    if (getPinchDistance(e) - initialPinchDistance > 20) {
      zoomFired = true;
      push('pdp_image_zoom', {
        gallery_position: getActiveSlideIndex(),
      });
    }
  }, { passive: true });

  gallery.addEventListener('touchend', function () {
    initialPinchDistance = null;
  }, { passive: true });

  // ── 4. Video Play ─────────────────────────────────────────

  var vid = gallery.querySelector('video');
  if (vid) {
    vid.addEventListener('play', function () {
      var slide = vid.closest('.fm-slider__slide');
      push('pdp_video_play', {
        video_title: vid.getAttribute('aria-label') || null,
        gallery_position: slide ? parseInt(slide.dataset.slideIndex, 10) : null,
      });
    }, { once: true });
  }

  // ── 5. Gallery Depth ──────────────────────────────────────

  var maxDepth = 1;
  var depthFired = false;

  // Update max depth on thumbnail click
  gallery.addEventListener('click', function (e) {
    var dot = e.target.closest('.js-fm-slider-dot');
    if (!dot) return;
    var parts = dot.id.split('-');
    var position = parseInt(parts[parts.length - 1], 10) + 1;
    if (position > maxDepth) maxDepth = position;
  });

  // Update max depth on swipe
  gallery.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;
    setTimeout(function () {
      var position = getActiveSlideIndex();
      if (position && position > maxDepth) maxDepth = position;
    }, 300);
  }, { passive: true });

  function fireGalleryDepth() {
    if (depthFired || maxDepth <= 1) return;
    depthFired = true;
    push('pdp_gallery_depth', {
      max_gallery_position: maxDepth,
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') fireGalleryDepth();
  });

  window.addEventListener('beforeunload', fireGalleryDepth);

})();